export enum RadioButtonGroupSelect {
    leftSelected = 'leftSelected',
    rightSelected = 'rightSelected',
}
